import { render, staticRenderFns } from "./CircleShimmer.vue?vue&type=template&id=372953b2&"
import script from "./CircleShimmer.vue?vue&type=script&lang=js&"
export * from "./CircleShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports